import type { PropsWithChildren } from 'react';
import { Dropdown } from 'react-bootstrap';
import { createPortal } from 'react-dom';

type DropdownMenuProps = {
  className?: string;
};

export const DropdownMenu = ({ className, children }: PropsWithChildren<DropdownMenuProps>) =>
  createPortal(<Dropdown.Menu className={className}>{children}</Dropdown.Menu>, document.body);
